import React from "react";
import Header from "../Header/Header";
import Footer from "./Footer";
import { Container } from "react-bootstrap";

const TermConditions = () => {
  return (
    <>
      <Header />
      <section className="first-webDevelopment-section">
        <Container>
          <div className="page-title text-center">
            <div style={{ color: "var(--primary-color)" }}>
              CODEFFI - Terms and Conditions
            </div>
            <h1>Terms and Conditions</h1>
            <div className="sub-info">
              <p>
                A company’s terms and conditions (T&C) are a legally binding
                agreement between the company and its customers or users. They
                outline the rules and regulations that govern the use of the
                company’s products or services.
              </p>
            </div>
          </div>

          <h4>Who we are</h4>
          <p>
            Our website address is:{" "}
            <a
              href="https://codeffi.com/"
              target="_blank"
              rel="noreferrer"
              style={{ color: "var(--primary-color)" }}
            >
              https://codeffi.com/
            </a>
          </p>

          <h4 className="mt-5">Comments</h4>
          <p>
            When visitors leave comments, we collect the data shown in the
            comments form, along with the visitor’s IP address and browser user
            agent string to help with spam detection.
          </p>
          <p>
            Once your comment is approved, it will be publicly visible. We may
            use automated spam detection services to ensure quality control.
          </p>

          <h4 className="mt-5">Media</h4>
          <p>
            If you upload images to our website, avoid including embedded
            location data (EXIF GPS), as visitors can download and extract such
            information from uploaded images.
          </p>

          <h4 className="mt-5">Cookies</h4>
          <p>
            If you leave a comment on our site, you may opt-in to saving your
            name, email address, and website in cookies. These are for your
            convenience so that you do not have to fill in your details again
            when leaving another comment. These cookies will last for one year.
          </p>
          <p>
            If you visit our login page, we will set a temporary cookie to
            determine if your browser accepts cookies. This cookie contains no
            personal data and is discarded when you close your browser.
          </p>

          <h4 className="mt-5">Embedded content from other websites</h4>
          <p>
            Articles on this site may include embedded content (e.g., videos,
            images, articles, etc.). Embedded content from other websites
            behaves in the same way as if the visitor has visited the other
            website.
          </p>

          <h4 className="mt-5">Who do we share your data with</h4>
          <p>
            We do not sell or share your personal data with third parties except
            when required by law or necessary to provide our services, such as
            payment processing and fraud prevention.
          </p>

          <h4 className="mt-5">How long we retain your data</h4>
          <p>
            If you leave a comment, the comment and its metadata are retained
            indefinitely. This is so we can recognize and approve any follow-up
            comments automatically instead of holding them in a moderation
            queue.
          </p>

          <h4 className="mt-5">What rights do you have over your data?</h4>
          <p>
            If you have an account on this site or have left comments, you can
            request to receive an exported file of the personal data we hold
            about you. You can also request that we erase any personal data we
            hold about you, except data we are obliged to keep for
            administrative, legal, or security purposes.
          </p>

          <h4 className="mt-5">Refund Policy</h4>
          <p>
            Refunds are processed based on the nature of the product or service
            purchased. Please refer to our refund policy page for detailed
            information on eligibility and timelines.
          </p>

          <h4 className="mt-5">Pricing</h4>
          <p>
            Our pricing is subject to change without prior notice. The final
            cost will be displayed at the time of purchase. Additional charges
            may apply based on the selected services.
          </p>
        </Container>
      </section>
      <Footer />
    </>
  );
};

export default TermConditions;
